import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast],
  template: `
    <p-toast position="top-right" />
    <router-outlet />
  `,
  styles: [],
})
export class AppComponent {
  private authService = inject(AuthService);

  ngOnInit() {
    const refreshToken = localStorage.getItem('refreshToken');

    if (refreshToken) {
      this.authService.startTokenRefresh();
    }
  }
}
